function startCountingIfNeeded(counterElement, options) {
    if (!counterElement.classList.contains('active')) {
        counterElement.classList.add('active');

        let targetValue = parseFloat(counterElement.getAttribute(options.dataName || 'data-number'));
        let isInteger = Number.isInteger(targetValue);

        let duration = options.duration || 2000;
        let stepTime = 10;

        let currentStep = 0;
        let totalSteps = duration / stepTime;

        let stepValue = targetValue / totalSteps;
        let currentValue = 0;

        let counter = setInterval(function() {
            currentValue += stepValue;
            currentStep++;

            if (isInteger) {
                counterElement.textContent = Math.round(currentValue);
            } else {
                if (currentValue < targetValue) {
                    counterElement.textContent = currentValue.toFixed(2).replace('.00', '');
                } else {
                    counterElement.textContent = targetValue.toFixed(2).replace('.00', '');
                }
            }

            if (currentStep >= totalSteps) {
                clearInterval(counter);
                counterElement.textContent = targetValue.toFixed(2).replace('.00', '');
            }
        }, stepTime);
    }
}
